




































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import FactoryRushCapacityProductGroup from "../../factory-rush-capacity-product-group.model";
import FactoryRushCapacitySlot from "../../factory-rush-capacity-slot.model";
import FactoryRushCapacityType from "../../factory-rush-capacity-type.model";

@Component
export default class FactoryRushCapacityViewForm extends Vue {
  @Prop({ required: true })
  public readonly groups!: FactoryRushCapacityProductGroup[];

  @Prop({ required: true })
  public readonly configuredSlots!: FactoryRushCapacitySlot[];

  @Prop({ required: true })
  public readonly types!: FactoryRushCapacityType[];

  get columnWidth(): string {
    const columnsCount = this.types.length ? this.types.length : 1;
    const value = Math.round((80 * 100) / columnsCount) / 100;

    return value.toString() + "%";
  }

  get visibleGroups(): FactoryRushCapacityProductGroup[] {
    return this.groups.filter((group) =>
      this.configuredSlots.some(
        (slot) => slot.productGroup.toString() === group.id.toString()
      )
    );
  }

  public getCapacityValue(groupId: string, typeId: string): string {
    const slot = this.configuredSlots.find(
      (item) =>
        item.productGroup.toString() === groupId.toString() &&
        item.type.toString() === typeId.toString()
    );

    return slot ? slot.capacity.toString() : "";
  }
}
